import type {
	AquacultureResponse,
	ModuleFull,
} from "@features/modules/aquaculture/types";
import { apiSlice, publicApiSlice, TagTypes } from "../../apiSlice";
import { FEModulesObj } from "../../../utils/moduleList";
import { FEModules } from "../../../utils/moduleList";
import { prepareModulePayload, transformModuleResponse } from "./factories/moduleApiUtils";
import { createModuleGetApi, createModuleUpdateApi } from "./factories/createModuleApi";

const includedPropList = [
	"id",
	"activity",
	"annual_production_start",
	"annual_production_w",
	"annual_production_wo",
	"note",
	"fish_type",
	"status",
	"annual_production_thread",
];
const includedT2PropList = [
	"n2o_from_production_t2_start",
	"n2o_from_production_t2_w",
	"n2o_from_production_t2_wo",
	"electricity_used_t2_start",
	"electricity_used_t2_w",
	"electricity_used_t2_wo",
];

//Define constants for the module
const MODULE_TYPE = "Aquaculture";
const TAG: TagTypes = "Aquaculture";
const TAG_DEFAULTS: TagTypes = "AquacultureDefaults";
const ENDPOINT = FEModulesObj[FEModules.Aquaculture].path;

const transformResponse = (response: AquacultureResponse) => transformModuleResponse<AquacultureResponse, ModuleFull>({
	response,
	includedPropList,
	includedT2PropList,
})

const aquacultureApiSlice = createModuleGetApi<ModuleFull>({
	apiSlice,
	path: ENDPOINT,
	moduleName: MODULE_TYPE,
	tag: TAG,
	tagDefaults: TAG_DEFAULTS,
	transformResponse,
})

const publicAquacultureApiSlice = createModuleGetApi<ModuleFull>({
	apiSlice: publicApiSlice,
	path: ENDPOINT,
	moduleName: MODULE_TYPE,
	tag: TAG,
	tagDefaults: TAG_DEFAULTS,
	transformResponse,
})

export const {
	useGetAquacultureQuery,
	useGetAquacultureDefaultsQuery,
} = aquacultureApiSlice;

export const {
	useGetAquacultureQuery: usePublicGetAquacultureQuery,
	useGetAquacultureDefaultsQuery: usePublicGetAquacultureDefaultsQuery,
} = publicAquacultureApiSlice;

const transformUpdatePayload = (data: Partial<ModuleFull>, activityId: number) => prepareModulePayload({
	moduleData: data.module,
	tiertwoData: data.tiertwo,
	activityId
})

const mutationApiSlice = createModuleUpdateApi<ModuleFull, AquacultureResponse>({
	apiSlice,
	path: ENDPOINT,
	moduleName: MODULE_TYPE,
	tag: TAG,
	tagDefaults: TAG_DEFAULTS,
	transformUpdatePayload,
})

export const {
	useUpdateAquacultureMutation,
} = mutationApiSlice;

export const aquacultureEndpoints = aquacultureApiSlice.endpoints;
export const aquacultureMutationEndpoints = mutationApiSlice.endpoints;